import * as React from 'react';
import { withConfig, ConfigProps } from 'ha/helpers/config';

import UserFlag from './UserFlag';
import EnvFlag from './EnvFlag';
import { RenderFn, FeatureFlags } from '../types';

interface OwnProps {
  feature: FeatureFlags;
  children: RenderFn;
}

export const FeatureFlag: React.SFC<OwnProps & ConfigProps> = ({
  feature,
  children,
  appConfig: { features },
}) =>
  features[feature] !== undefined ? (
    <EnvFlag feature={feature} envFeatures={features} children={children} />
  ) : (
    <UserFlag feature={feature} children={children} />
  );

export default withConfig(FeatureFlag);
